import { EsLogoGearColorIcon } from "@equipmentshare/ds2-icons";
import { COLOR_SHADE } from "@equipmentshare/t3-design-tokens";
import { Button, Card, Collapse, Grid } from "antd";
import styled from "styled-components";

import { SelectComponentStyledProps } from "./types";

import { TokenProps } from "~/types";

export const GearSpinner = styled(EsLogoGearColorIcon)`
  @keyframes rotating {
    from {
      transform: rotate(360deg);
    }
    to {
      transform: rotate(0deg);
    }
  }
  animation: rotating 1.75s linear infinite;
`;

export const createSharedSelectStyles = ({
  $token,
  $isSelected,
}: SelectComponentStyledProps) => {
  const defaultStyles = `
    border: 1px solid ${COLOR_SHADE.LIGHT};
  `;

  if ($isSelected) {
    return `
      ${defaultStyles}
      background-color: ${$token.blue1} !important;
      border-color: ${$token.colorPrimaryBorder} !important;

      & * {
        background-color: ${$token.blue1} !important;
      }
    `;
  } else {
    return `
      ${defaultStyles}
      background-color: ${COLOR_SHADE.EMPTY} !important;
      color: ${COLOR_SHADE.FULL} !important;

      &:hover,
      &:hover *:not(span) {
        background-color: #e3e5e8 !important;
        border-color: #e3e5e8 !important;
      }
    `;
  }
};

export const ButtonSelectStyled = styled(Button)<SelectComponentStyledProps>`
  ${({ $isSelected, $token }) =>
    `
    font-weight: bold;

    ${createSharedSelectStyles({ $isSelected, $token })}
    `}
`;

export const PanelSelectStyled = styled.div<SelectComponentStyledProps>`
  ${({ $isSelected, $token }) =>
    `
    cursor: pointer;
    padding: 1rem;
    border-radius: ${$token.borderRadius}px;

    ${createSharedSelectStyles({ $isSelected, $token })}
    `}
`;

export const CarouselCard = styled(Card)`
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.1);
  max-width: 18.75rem;
`;

export const ResponsiveSelectWrapper = styled.div<{
  $elRect?: DOMRect;
  $breakpoints: ReturnType<typeof Grid.useBreakpoint>;
}>`
  position: relative;
  & > select.html-select {
    display: ${(props) => (props.$breakpoints.md ? "none" : "block")};
    height: ${(props) => (props.$elRect?.height || 0) + 18}px;
    opacity: 0;
    position: absolute;
    width: ${(props) => props.$elRect?.width || 0}px;
    z-index: 1;
  }
`;

export const CollapseStyled = styled(Collapse)`
  display: block;
  .ant-collapse-content-box {
    padding-left: 0 !important;
    padding-top: 0 !important;
  }
  .ant-collapse-header {
    padding-left: 0 !important;
  }
  .ant-collapse-content-box {
    font-size: 1rem !important;
  }
  .ant-collapse-content > ul,
  .ant-collapse-content ul {
    font-size: 1rem !important;
  }
`;

export const AccordionLabel = styled.p<TokenProps>`
  color: ${(props) => props.$token.colorTextSecondary} !important;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.025rem !important;
  line-height: 1.5rem;
  margin-block-end: 0;
  margin-block-start: 0;
`;

export const AccordionContent = styled.div<TokenProps>`
  p {
    color: ${(props) => props.$token.colorTextSecondary};
    font-size: 1rem;
    line-height: 1.5rem;
    margin-block-end: 1rem;
    margin-block-start: 0 !important;
    margin-bottom: 1rem;
    margin-inline-end: 0;
    margin-inline-start: 0;
    margin-top: 0;
  }
`;
